import { CaretDownOutlined, CaretUpOutlined, PlusOutlined } from "@ant-design/icons"
import { Button, Input, List, message, Radio, Typography } from "antd"
import React, { useEffect, useState } from "react"
import { t } from "~/languages/i18n"
import { AttributesDepartment, DepartmentOption, DepartmentProps } from "~/types/types"
import { createDepartment, fetchDepartment } from "../services/recruitment"

const { Title } = Typography

const Department: React.FC<DepartmentProps> = ({ selectedDepartment, onChangeDepartment }) => {
  const [isDepartmentListVisible, setDepartmentListVisible] = useState(true)
  const [Department, setDepartment] = useState<DepartmentOption[] | null>([])
  const [isAddingTag, setIsAddingTag] = useState(false)
  const [newTagName, setNewTagName] = useState("")

  const handleFetchTag = async () => {
    try {
      const response = await fetchDepartment()
      const DepartmentData = response.data
      if (Array.isArray(DepartmentData)) {
        const tagOptions = DepartmentData.map(tag => ({
          id: tag.id,
          label: tag.attributes.Name,
          value: tag.id,
          disabled: false,
        }))
        setDepartment(tagOptions)
      }
    } catch {
      console.error(t("Error fetching Department"))
    }
  }

  useEffect(() => {
    handleFetchTag()
  }, [])

  const handleAddTag = async () => {
    if (newTagName) {
      try {
        const data: AttributesDepartment = {
          Name: newTagName,
        }
        const response = await createDepartment(data)

        await handleFetchTag()

        setNewTagName("")
        setIsAddingTag(false)
        message.success(t(`Added new tag: ${newTagName}`))
      } catch {
        message.error(t("Error adding tag"))
      }
    } else {
      message.error(t("Please enter a tag name"))
    }
  }

  return (
    <div className="Department border border-gray-300 rounded-[10px] mb-5">
      <div className="flex justify-between items-center px-4 py-2 border-b">
        <Title level={4} className="!m-0">
          {t("Department")}
        </Title>
        <Button
          onClick={() => setDepartmentListVisible(!isDepartmentListVisible)}
          className="flex items-center"
          icon={isDepartmentListVisible ? <CaretDownOutlined /> : <CaretUpOutlined />}
          type="text"
        />
      </div>

      {isDepartmentListVisible && (
        <div className="mb-5">
          <Radio.Group
            onChange={e => onChangeDepartment(e.target.value)}
            value={selectedDepartment}
            className="w-[100%] pt-2"
          >
            <List
              className="w-[100%]"
              size="small"
              dataSource={Department ?? []}
              renderItem={item => (
                <List.Item>
                  <Radio value={item.label}>{item.label}</Radio>
                </List.Item>
              )}
            />
          </Radio.Group>
          <div className="px-4">
            <Button icon={<PlusOutlined />} onClick={() => setIsAddingTag(!isAddingTag)}>
              {t("Add New Department")}
            </Button>
            {isAddingTag && (
              <div className="mt-4 flex">
                <Input
                  placeholder={t("Enter department name")}
                  value={newTagName}
                  onChange={e => setNewTagName(e.target.value)}
                  style={{ marginRight: "8px" }}
                />
                <Button type="primary" onClick={handleAddTag}>
                  {t("Add")}
                </Button>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default Department
